import React from 'react';
import { useSelector } from 'react-redux';
import MessageBox from './MessageBox';

const PaymentCheck = ({ children, custom_message = null }) => {
  const payment = useSelector(state => state.studentAccount.payment);
  const paymentStatus = payment?.status || 'inactive';

  if (paymentStatus === 'active') {
    return children;
  } else {
    return (
      <MessageBox
        title="Payment Required"
        message="Your payment is not active. Please make a payment to continue."
        type="warning"
      />
    );
  }
};

export default PaymentCheck;
